import React from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../assets/Logo.svg";
import styles from "./CreatorApplicationLayout.module.css";
import FooterCommon from "./FooterCommon";

type CreatorApplicationLayoutProps = {
  children: React.ReactNode;
  logoTarget?: string;
  onLogoClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

export default function CreatorApplicationLayout({
  children,
  logoTarget: customLogoTarget,
  onLogoClick,
}: CreatorApplicationLayoutProps) {
  const location = useLocation();
  const isMemberOnboarding = location.pathname.startsWith("/member-onboarding-step");
  const logoTarget = customLogoTarget !== undefined ? customLogoTarget : (isMemberOnboarding ? "/member-onboarding-step" : "/");

  return (
    <div className={styles.wrapper}>
      {/* ── Header ── */}
      <header className={styles.header}>
        <div className={styles.headerInner}>
          {/* Logo */}
          <Link to={logoTarget} onClick={onLogoClick} className={styles.logoLink}>
            <img src={Logo} alt="SugarCribs" className={styles.logo} />
          </Link>

          {/* Help Button */}
          <button className={styles.helpBtn}>Need Help?</button>
        </div>
      </header>

      {/* ── Page Content ── */}
      <main className={styles.content}>{children}</main>

      {/* ── Footer ── */}
      <FooterCommon />
    </div>
  );
}
